module.exports = __webpack_public_path__ + "img/w3_circle_left_light.1bfceae7.png";